export default __webpack_public_path__ + "static/media/review_bg.ac819c2c.png";